// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-link[data-v-4b1380bf]{font-size:1.8em}", "",{"version":3,"sources":["webpack://./resources/js/layouts/components/HomeBar.vue"],"names":[],"mappings":"AAiBA,4BACI,eAhBJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"resources/sass/variables\";\n\n.home-link {\n    font-size: 1.8em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
